import { render, staticRenderFns } from "./ModalAddUser.vue?vue&type=template&id=47249d50&"
import script from "./ModalAddUser.vue?vue&type=script&lang=js&"
export * from "./ModalAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports